import { render, staticRenderFns } from "./virtualListItem.vue?vue&type=template&id=097b65ad"
import script from "./virtualListItem.vue?vue&type=script&lang=js"
export * from "./virtualListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports